/***************************************************************
8/7/2017
Alexander Self
Dashboard container
- Main dashboard container
***************************************************************/
import { BarChart, StackedBarChart, LineChart, StackedBarChartWithLine } from '../components/charts/misc_chart';
import { fetchData, switchLocation, enlargeGraphs, fetchHeadCount, sortByOperation,
  fetchHoursByField, fetchHoursByDepartment, fetchMissingTimesheets } from '../actions/dashboard_actions';
import { fetchUserProfile } from '../actions/index';
//import { sortByDate } from '../reducers/dashboard_reducer';
//import { LABORS_HOURS_BY_FIELD, DENSITY_BY_FIELD } from '../constants';
//import DashboardCard from '../components/dashboard/dashboard_card';
//import DensityTable from '../components/dashboard/dashboard_table_density';
//import FieldHoursTable from '../components/dashboard/dashboard_table_fieldHours';
import EquipmentHours from '../components/dashboard/dashboard_equipmenthours';
//import AttendanceTable from '../components/dashboard/dashboard_table_attendance';
//import HeadCount from '../components/dashboard/dashboard_headcount';
import MissingTimesheet from '../components/dashboard/dashboard_missingTimesheet';
//import DepartmentTable from '../components/dashboard/dashboard_table_departmentHours';
//import Leaderboard from '../components/dashboard/dashboard_leaderBoard';
//import HoursInfoCard from '../components/dashboard/dashboard_info_card';
//import DateRange from '../components/date_range';
import React, { Component } from 'react';
import moment from 'moment';
//import { Sparklines, SparklinesLine } from 'react-sparklines';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stackedChart: null,
      barChart: null,
      curChart: null,
      linechart: null,
      barLineChart: null,
      field: null
    };
    this.drawStackedChart = this.drawStackedChart.bind(this);
    this.drawHoursByFieldBarChart = this.drawHoursByFieldBarChart.bind(this);
    this.drawBagTreeDensities = this.drawBagTreeDensities.bind(this);
  }
  componentDidMount() { // Need to make sure data is not fetched twice
    if (this.props.eid) {
      this.props.fetchData();
      if (!this.props.user.firstName) this.props.fetchUserProfile(this.props.eid);
    }
    document.title = 'Time Management';
  }
  componentWillReceiveProps(newProps) {
    // Draw charts here
    //this.drawStackedChart(newProps.hoursByDepartment);
    //this.drawHoursByFieldBarChart(newProps.fieldHours);
    //this.drawBagTreeDensities(newProps.bagDensities);
  }
  drawStackedChart(props) {
    if (!props) return;
    if (this.state.stackedChart) this.state.stackedChart.update();

    var ctx = document.getElementById("stackedChart");
    let labels = props.map((val) => val.department);
    let regHours = props.map((val) => val.regHours);
    let otHours = props.map((val) => val.otHours);

    var myChart = StackedBarChart(ctx, labels, regHours, otHours, 'Regular Hours', 'Overtime');

    this.setState({stackedChart: myChart});
  }
  drawHoursByFieldBarChart(props) {
    if (!props) return;
    if (this.state.barChart) this.state.barChart.destroy();

    var ctx = document.getElementById("barChart");
    var labels = props.map((val) => val.field);
    var hours = props.map((val) => val.totalHours);

    var barChart = BarChart(ctx, labels, hours, '', 'Total Hours');

    this.setState({barChart});
  }
  drawnLineChart(props) {
    if (!props) return;
    if (this.state.lineChart) this.state.lineChart.update();

    var ctx = document.getElementById("lineChart");
    var labels = props.map((val) => val.field);
    var hours = props.map((val) => val.totalHours);

    var lineChart = LineChart(ctx, labels, hours, 'Hours By Field', 'Total Hours');

    this.setState({lineChart});
  }
  drawBagTreeDensities(props) {
    if (!props) return;
    if (this.state.barLineChart) this.state.barLineChart.destroy();

    var ctx = document.getElementById("barLineChart").getContext("2d");
    var labels = props.map((val) => val.field);
    var trees = props.map((val) => val.treesCovered);
    var bags = props.map((val) => val.bagsCount);
    var densities = props.map((val) => val.density);
    // Params: ctx, labels, data1, data2, data3, label1, label2, label3
    var barLineChart = StackedBarChartWithLine(ctx, labels, densities, trees, bags, 'Density', 'Trees', 'Bags');

    this.setState({barLineChart});
  }

  componentDidUpdate(prevProps, prevState) {
    // Do nothing dates={<DateRange dateID1={'department-date-1'} dateID2={'department-date-2'} onClick={() => Materialize.toast('Available soon!', 'green rounded' ,3000)} />}
  }
  render() {
    return (
      <div>
        <h5>Dashboard <button onClick={this.props.enlargeGraphs} className="btn waves-effect graph-resize">{ this.props.graphSize === '6' ? 'Enlarge Graphs' : 'Shrink Graphs' }</button>
          <span className="flow-text right">{ moment().format("dddd, MMMM Do YYYY") }</span>
        </h5>
        <hr />
        <div className="row">
          {/*<div className={`col s12 m12 l${this.props.graphSize} xl${this.props.graphSize}`}>
            <DashboardCard canvasId={'stackedChart'} label={'Hours by Department'}
              child={<DepartmentTable departments={this.props.hoursByDepartment} />}

            />
          </div>
          <div className={`col s12 m12 l${this.props.graphSize} xl${this.props.graphSize}`}>
            <DashboardCard inputs={LABORS_HOURS_BY_FIELD} canvasId={'barChart'} label={'Labor Hours By Field'}
              child={<FieldHoursTable fieldHours={this.props.fieldHours} />} switchLocation={this.props.switchLocation}
              dates={<DateRange dateID1={'field-date-1'} dateID2={'field-date-2'} onClick={this.props.fetchHoursByField} />}
            />
          </div>
          <div className={`col s12 m12 l${this.props.graphSize} xl${this.props.graphSize}`}>
            <DashboardCard inputs={DENSITY_BY_FIELD} canvasId={'barLineChart'} label={'Bags, Trees, Densities By Field'}
              child={<DensityTable densities={this.props.bagDensities} />} switchLocation={this.props.switchLocation} />
          </div>*/}
          {/*<div className={`col s12 m12 l${this.props.graphSize} xl${this.props.graphSize}`}>
            <div className="card">
              <Leaderboard leaderBoard={this.props.leaderBoard} totalLbs={this.props.totalLbs} switchLocation={this.props.switchLocation} />
            </div>
          </div>
          <div className={`col s12 m12 l${this.props.graphSize} xl${this.props.graphSize}`}>
            <div className="card">
              <HeadCount headCount={this.props.headCount} switchLocation={this.props.switchLocation}
                fetchHeadCount={this.props.fetchHeadCount} headCountDate={this.props.headCountDate} />
            </div>
          </div>
          */}

          <div className={`col s12 m12 l${this.props.graphSize} xl${this.props.graphSize}`}>
            <div className="card">
              <MissingTimesheet empsWOTS={this.props.empsWOTS} fetchMissingTimesheets={this.props.fetchMissingTimesheets} />
            </div>
          </div>
          <div className={`col s12 m12 l${this.props.graphSize} xl${this.props.graphSize}`}>
            <div className="card">
              <EquipmentHours equipmentHours={this.props.equipmentHours} sortBy={this.props.sortByOperation} />
            </div>
          </div>
        </div>

        {/*<div className="row">
          <div className="col s12 m6 l3 xl3">
            <HoursInfoCard
              label={'Total Hours'}
              icon={'trending_up'}
              data={this.props.laborHours.totalHours}
              color={'blue-grey'}
              stats={this.props.laborHours.tHours}
              child={<Sparklines data={this.props.laborHours.tHours} height={20}>
                <SparklinesLine style={{ stroke: "white", strokeWidth: "1", fill: "#b0bec5", fillOpacity: "0.5" }}  />
              </Sparklines>} />
          </div>
          <div className="col s12 m6 l3 xl3">
            <HoursInfoCard
              label={'Regular Hours'}
              icon={'hourglass_full'}
              data={this.props.laborHours.totalRegtime}
              color={'green'}
              stats={this.props.laborHours.tReg}
              child={<Sparklines data={this.props.laborHours.tReg} height={20}>
                <SparklinesLine style={{ stroke: "white", strokeWidth: "1", fill: "#a5d6a7", fillOpacity: "0.5" }}  />
              </Sparklines>} />
          </div>
          <div className="col s12 m6 l3 xl3">
            <HoursInfoCard
              label={'Overtime Hours'}
              icon={'report_problem'}
              data={this.props.laborHours.totalOvertime}
              color={'red'}
              stats={this.props.laborHours.tOT}
              child={<Sparklines data={this.props.laborHours.tOT} height={20}>
                <SparklinesLine style={{ stroke: "white", strokeWidth: "1", fill: "#ef9a9a", fillOpacity: "0.5" }}  />
              </Sparklines>} />
          </div>
          <div className="col s12 m6 l3 xl3">
            <HoursInfoCard
              label={'Doubletime Hours'}
              icon={'error'}
              data={this.props.laborHours.totalDoubletime}
              color={'purple'}
              stats={this.props.laborHours.tDT}
              child={<Sparklines data={this.props.laborHours.tDT} height={20}>
                <SparklinesLine style={{ stroke: "white", strokeWidth: "1", fill: "#ce93d8", fillOpacity: "0.5" }}  />
              </Sparklines>} />
          </div>
        </div>*/}
        <div className="row">
          <div className="card">
            <h4>{ this.state.field }</h4>
          </div>

        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    authenticated: state.auth.authenticated,
    bagDensities: state.dashboard.bagDensities.displaying,
    eid: state.auth.user.guid,
    employeeAttendance: state.dashboard.employeeAttendance.displaying,
    empsWOTS: state.dashboard.empsWOTS,
    equipmentHours: state.dashboard.equipmentHours,
    fieldHours: state.dashboard.fieldHours.displaying,
    graphSize: state.dashboard.graphSize,
    headCount: state.dashboard.headCount,
    headCountDate: state.dashboard.headCountDate,
    hoursByDepartment: state.dashboard.hoursByDepartment,
    laborHours: state.dashboard.laborHours,
    leaderBoard: state.dashboard.leaderBoard.displaying,
    totalLbs: state.dashboard.leaderBoard.totalLbs,
    user: state.auth.user
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchData,
    switchLocation,
    fetchUserProfile,
    enlargeGraphs,
    fetchHeadCount,
    sortByOperation,
    fetchHoursByField,
    fetchHoursByDepartment,
    fetchMissingTimesheets
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);

/*if ('caches' in window) {
  caches.open('test-cache').then((cache) => {
    cache.addAll(['/', '/img/geo.png'])
      .then(() => {
        console.log('Geo.png is cached!');
      });
  });
}
['a','b','c','d','e','f','g','h','i','j','k'].map((v, i) => {
  localforage.setItem(v, i).then((val) => {
    console.log(val)
  }).catch((err) => {
    console.log(err);
  });
});
*/

/* END */



// WEBPACK FOOTER //
// ./src/containers/dashboard.js